import request from '@/utils/request';
import SERVICE from './enums';
//------------// 图表订阅模块-----------------
// 新增
export function addShare(data) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/templateShareInfo`,
    method: "post",
    data
  });
}

// 获取用户信息
export function getUserNames(params) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/authority`,
    method: "post",
    data: {},
    params
  });
}

// 更新分享状态
export function switchShare(id, status)  {
  return request({
    url: `${SERVICE.API_ANALYSIS}/templateShareInfo/share/${id}/${status}`,
    method: "put",
    data: {},
  });
}

// 分享历史
export function shareHistory(data) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/templateShareInfo/history`,
    method: "post",
    data
  });
}



// 系统分享
export function systemShareList(data) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/templateShareInfo/auto-visible`,
    method: "post",
    data
  });
}
// 获取模板， 外部
export function getFinanceIdList(params) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/authority/get-advertisers`,
    method: "post",
    data: {},
    params,
  });
}
// 他人分享
export function shareModalList(data) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/templateShareInfo/page`,
    method: "post",
    data
  });
}
// 他人分享
export function getEnterpriseUsers(params) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/authority/users`,
    method: "post",
    data: {},
    params
  });
}

// 分析接口， 外部
export function previewOuter(id, data) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/templateShareInfo/without/analysis/${id}`,
    method: "post",
    data,
  });
}
// 获取模板， 外部
export function getAnalysisTemplatesDetailsOuter(id) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/templateShareInfo/without/${id}`,
    method: "get",
  });
}
// 获取模板， 外部
export function getPreviewOuter(params, data = {}) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/templateShareInfo/without/preview`,
    method: "post",
    params,
    data,
  });
}
/*  内部分享    */
// 分析接口， 外部
export function previewInternal(id, data) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/templateShareInfo/within/analysis/${id}`,
    method: "post",
    data,
  });
}
// 获取模板， 外部
export function getAnalysisTemplatesDetailsInternal(id) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/templateShareInfo/within/${id}`,
    method: "get",
  });
}
// 获取模板， 外部
export function getPreviewInternal(params, data = {}) {
  return request({
    url: `${SERVICE.API_ANALYSIS}/templateShareInfo/within/preview`,
    method: "post",
    params,
    data,
  });
}

// 编辑状态
export function switchEdit(id, status)  {
  return request({
    url: `${SERVICE.API_ANALYSIS}/templateShareInfo/share/w/${id}/${status}`,
    method: "put",
    data: {},
  });
}